/* cf-rake-label.js — name rake panels the way they are actually ordered.
 *
 * Pete, 2026-09-03: "i selected the 1800 high rake panel but the plan said retained
 * hieght 200mm. lets get rid of this terminology and call the rake panels what they
 * are called normally like: 1800 rake panel etc."
 *
 * WHAT THE LABEL SAID. The preview caption is built as
 *     {panel width}mm Raked Panel   /   ({retainedHeight}mm retained)
 * so the number a customer reads first is the WIDTH, and the second is legacy "retained
 * height" wording from when the field meant the extra height above a 1200 base. The
 * James Glen product is sold by tall edge — variants run 1300mm to 2100mm
 * ("1800mm — 12X450X1800X1200X1200MM") — and the parts list already names it correctly
 * as "Left Rake Panel (1800mm)". Only the caption and the form label disagreed.
 *
 * WHAT IT SAYS NOW.   1800mm Rake Panel
 *                     1200mm wide
 * matching the parts list, the cart line and the purchase order. The caption is also
 * what gets rasterised into the plan PDF, so the drawing agrees with the parts list too.
 *
 * TWO TEXT NODES, NOT ONE. The caption is two sibling elements — "1200mm Raked Panel"
 * and "(1800mm retained)" — so a regex run against a single text node never matches.
 * The first version of this file did exactly that and silently did nothing; caught on
 * the theme preview. Both halves are rewritten together, from the element that contains
 * them both.
 *
 * THE 200 CASE. "(200mm retained)" is not a choice anyone can make — the dropdown only
 * offers 1300-2100. It is a hard-coded fallback shown when retainedHeight is missing,
 * which happened on every plan saved before cf-plans.js began persisting it. Those show
 * "Rake Panel" with no height rather than a number we do not trust: a missing figure is
 * recoverable, a confidently wrong one gets the wrong panel ordered.
 *
 * Display only. No price, variant, quantity or cart line is touched.
 */
(function () {
  'use strict';

  var TAG = '[cf-rake-label]';
  var RETAINED_RE = /\(\s*(\d+)\s*mm\s+retained\s*\)/i;
  var NAME_RE     = /(\d+)\s*mm\s*Raked\s*Panel/i;
  var BOTH_RE     = /(\d+)\s*mm\s*Raked\s*Panel\s*\(\s*(\d+)\s*mm\s+retained\s*\)/i;
  // The real variant ladder starts at 1300; anything below it is the fallback.
  var MIN_REAL_HEIGHT = 1300;
  var MAX_TRIES = 200;
  var tries = 0;

  function panelName(height) {
    var h = parseInt(height, 10);
    return (isFinite(h) && h >= MIN_REAL_HEIGHT) ? h + 'mm Rake Panel' : 'Rake Panel';
  }

  function textNodesUnder(el) {
    var out = [];
    try {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) out.push(n);
    } catch (e) { /* ignore */ }
    return out;
  }

  /* The caption is split across sibling elements, so rewrite from the node that holds
     the retained figure: walk up one level and find the width half beside it. */
  function fixSplitCaption(retainedNode) {
    var m = RETAINED_RE.exec(retainedNode.nodeValue || '');
    if (!m) return false;
    var container = retainedNode.parentElement && retainedNode.parentElement.parentElement;
    if (!container) return false;

    var nodes = textNodesUnder(container);
    for (var i = 0; i < nodes.length; i++) {
      var nameNode = nodes[i];
      if (nameNode === retainedNode) continue;
      var nm = NAME_RE.exec(nameNode.nodeValue || '');
      if (!nm) continue;
      var width = nm[1];
      var wantName = panelName(m[1]);
      var wantWide = width + 'mm wide';
      if (nameNode.nodeValue !== wantName) nameNode.nodeValue = wantName;
      if (retainedNode.nodeValue !== wantWide) retainedNode.nodeValue = wantWide;
      return true;
    }
    return false;
  }

  function sweep() {
    var n = 0;
    try {
      var nodes = textNodesUnder(document.body);
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        var v = node.nodeValue;
        if (!v) continue;

        // Whole caption in one node.
        var both = BOTH_RE.exec(v);
        if (both) {
          var next = v.replace(BOTH_RE, panelName(both[2]) + ' — ' + both[1] + 'mm wide');
          if (next !== v) { node.nodeValue = next; n++; }
          continue;
        }

        // Split across two elements - the normal case.
        if (RETAINED_RE.test(v) && fixSplitCaption(node)) { n++; continue; }

        // The form label above the dropdown.
        if (v.indexOf('Retained Panel Height') >= 0) {
          node.nodeValue = v.replace(/Retained Panel Height/g, 'Rake Panel Height');
          n++;
        }
      }
    } catch (e) {
      console.warn(TAG, 'sweep', e);
    }
    return n;
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      try { sweep(); } catch (e) { console.warn(TAG, 'scheduled', e); }
    }, 60);
  }

  function install() {
    if (window.__cfRakeLabel) return true;
    if (!document.body) return false;
    window.__cfRakeLabel = true;

    sweep();
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body,
        { childList: true, subtree: true, characterData: true });
    }
    // The calculator redraws the preview on its own timer; this is the safety net.
    setInterval(sweep, 1500);

    console.log(TAG, 'installed');
    return true;
  }

  function tryInstall() {
    var done = false;
    try { done = install(); } catch (e) { console.warn(TAG, 'install', e); }
    if (!done && ++tries < MAX_TRIES) setTimeout(tryInstall, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInstall);
  } else {
    tryInstall();
  }
})();
